import { useEffect, useRef } from "react";
import type { FC } from "react";
import { mountPlumb } from "./engine";
import type { Mode, Overlay, PaletteName, PlumbHandle } from "./engine";

interface Props {
  src: string;
  depth?: string;
  mode?: Mode | "auto";
  overlay?: Overlay | "auto" | "none";
  fx?: number;
  fy?: number;
  nodes?: number;
  tempo?: number;
  palette?: PaletteName;
  className?: string;
}

/** A still picture read by Plumb, filling its box like `object-fit: cover`. */
export const Plumb: FC<Props> = ({
  src,
  depth,
  mode = "auto",
  overlay = "auto",
  fx,
  fy,
  nodes,
  tempo,
  palette = "acid",
  className,
}) => {
  const ref = useRef<HTMLCanvasElement>(null);
  const handle = useRef<PlumbHandle | null>(null);
  const first = useRef({ mode, overlay });

  useEffect(() => {
    if (!ref.current) return;
    const mounted = mountPlumb(ref.current, { src, depth, fx, fy, nodes, tempo, palette, ...first.current });
    handle.current = mounted;
    return () => mounted.destroy();
  }, [src, depth, fx, fy, nodes, tempo, palette]);

  useEffect(() => {
    first.current = { mode, overlay };
    handle.current?.set({ mode, overlay });
  }, [mode, overlay]);

  return <canvas ref={ref} aria-hidden className={`plumb ${className ?? ""}`} />;
};
